import { type ReactElement } from 'react';
import { AmazonDoorAccessPage } from '@citibox-panel/lockers-operations';
import { UserMenu } from '@/features/user-menu';
import { MARKET_LABELS, resolveMarket, resolveMarketIndicator } from '@/lib/marketIndicator';
import { readRuntimeConfig } from '@/lib/runtimeConfig';
import { useSession } from '@/lib/session';
import {
  fetchDoorAccessCount,
  fetchDoorAccessLocation,
  setDoorAccessForLocations,
} from '@/lib/apiClient';

// The composition root for the operations screen, exactly as HomeView is for the care shell: it
// resolves the runtime config and picks the reads and the write, so the module stays free of any
// apps/shell dependency and knows neither its own URL nor whether it is talking to a mock.
export function AmazonDoorAccessRoute(): ReactElement {
  const { roleNames } = useSession();
  // Read once and shared by both resolvers, rather than twice.
  const config = readRuntimeConfig();
  const indicator = resolveMarketIndicator(config);
  const market = resolveMarket(config);
  // The BARE label the confirmation needs («ES»), not the brand pill's text («Soporte ES»), and
  // `null` when the deployment cannot be trusted to name its market — the dialog says so rather
  // than printing a dash where the market should be.
  const marketLabel = market === null ? null : MARKET_LABELS[market];

  return (
    <AmazonDoorAccessPage
      brandLabel={indicator.text}
      brandDegraded={indicator.degraded}
      headerEnd={<UserMenu roleNames={roleNames} />}
      fetchDoorAccessCount={fetchDoorAccessCount}
      setDoorAccess={setDoorAccessForLocations}
      fetchDoorAccessLocation={fetchDoorAccessLocation}
      marketLabel={marketLabel}
    />
  );
}
